import React from "react"
import Slider from "react-slick"

import t from "../locale"

const OfficesSliderTowerLowerFirstSecondFloor = ({ lang }) => {
  const officesSlider = {
    dots: true,
    arrows: true,
    infinite: true,
    fade: true,
    speed: 750,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 575,
        settings: {
          arrows: false,
        },
      },
    ],
  }

  return (
    <Slider {...officesSlider}>
      <div>
        <div className="offices-schema__wrapper">
          <div className="offices-schema__wrapper-top">
            <h3>{t("Sample arrangements of an office", lang)}:</h3>
            <div>
              <h4>
                {t("Modern version (floor 1)", lang)} {t("", lang)}
              </h4>
              <p>
                860,55{" "}
                <span
                  dangerouslySetInnerHTML={{ __html: t("sqm GLA", lang) }}
                />
              </p>
              <p>57 {t("workplaces", lang)}</p>
            </div>
          </div>
          <div className="img__wrapper">
            <img
              src={require("../assets/images/Unity_Tower_first_floor/UT_1P_modern_v2.png")}
              alt=""
            />
          </div>
          <div className="offices-schema__wrapper-bottom">
            <ul>
              <li>{t("1 office room / 1 person", lang)}</li>
              <li>{t("5 office rooms / 2 persons", lang)}</li>
              <li>{t("1 office room / 4 persons", lang)}</li>
              <li>{t("Reception desk", lang)}</li>
              <li>{t("4 conference rooms", lang)}</li>
              <li>{t("Kitchen", lang)}</li>
              <li>{t("Relax area", lang)}</li>
            </ul>
            <a
              href={
                lang === "en"
                  ? require("../assets/pdf/UNITY-TOWER-1st-floor-modern_v2-en.pdf")
                  : require("../assets/pdf/UNITY-TOWER-1st-floor-modern_v2.pdf")
              }
              target="_blank"
              rel="noreferrer"
              className="btn-custom-back btn-custom-back--orange"
            >
              {t("Download Floor Plan", lang)}
            </a>
          </div>
        </div>
      </div>
      <div>
        <div className="offices-schema__wrapper">
          <div className="offices-schema__wrapper-top">
            <h3>{t("Sample arrangements of an office", lang)}:</h3>
            <div>
              <h4>
                {t("Traditional version (floor 1)", lang)} {t("", lang)}
              </h4>
              <p>
                860,55{" "}
                <span
                  dangerouslySetInnerHTML={{ __html: t("sqm GLA", lang) }}
                />
              </p>
              <p>98 {t("workplaces", lang)}</p>
            </div>
          </div>
          <div className="img__wrapper">
            <img
              src={require("../assets/images/Unity_Tower_first_floor/UT_1P_traditional_v2.png")}
              alt=""
            />
          </div>
          <div className="offices-schema__wrapper-bottom">
            <ul>
              <li>{t("Reception desk", lang)}</li>
              <li>{t("4 conference rooms", lang)}</li>
              <li>{t("Kitchen", lang)}</li>
              <li>{t("Relax area", lang)}</li>
            </ul>
            <a
              href={
                lang === "en"
                  ? require("../assets/pdf/UNITY-TOWER-1st-floor-traditional_v2-en.pdf")
                  : require("../assets/pdf/UNITY-TOWER-1st-floor-traditional_v2.pdf")
              }
              target="_blank"
              rel="noreferrer"
              className="btn-custom-back btn-custom-back--orange"
            >
              {t("Download Floor Plan", lang)}
            </a>
          </div>
        </div>
      </div>
      <div>
        <div className="offices-schema__wrapper">
          <div className="offices-schema__wrapper-top">
            <h3>{t("Sample arrangements of an office", lang)}:</h3>
            <div>
              <h4>
                {t("Modern version (floor 2)", lang)} {t("", lang)}
              </h4>
              <p>
                817,39{" "}
                <span
                  dangerouslySetInnerHTML={{ __html: t("sqm GLA", lang) }}
                />
              </p>
              <p>53 {t("workplaces", lang)}</p>
            </div>
          </div>
          <div className="img__wrapper">
            <img
              src={require("../assets/images/Unity_Tower_second_floor/UT_2P_modern_v2.png")}
              alt=""
            />
          </div>
          <div className="offices-schema__wrapper-bottom">
            <ul>
              <li>{t("1 office room / 1 person", lang)}</li>
              <li>{t("5 office rooms / 2 persons", lang)}</li>
              <li>{t("Reception desk", lang)}</li>
              <li>{t("3 conference rooms", lang)}</li>
              <li>{t("Kitchen", lang)}</li>
              <li>{t("Relax area", lang)}</li>
            </ul>
            <a
              href={
                lang === "en"
                  ? require("../assets/pdf/UNITY-TOWER-2nd-floor-modern_v2-en.pdf")
                  : require("../assets/pdf/UNITY-TOWER-2nd-floor-modern_v2.pdf")
              }
              target="_blank"
              rel="noreferrer"
              className="btn-custom-back btn-custom-back--orange"
            >
              {t("Download Floor Plan", lang)}
            </a>
          </div>
        </div>
      </div>
      <div>
        <div className="offices-schema__wrapper">
          <div className="offices-schema__wrapper-top">
            <h3>{t("Sample arrangements of an office", lang)}:</h3>
            <div>
              <h4>
                {t("Traditional version (floor 2)", lang)} {t("", lang)}
              </h4>
              <p>
                817,39{" "}
                <span
                  dangerouslySetInnerHTML={{ __html: t("sqm GLA", lang) }}
                />
              </p>
              <p>98 {t("workplaces", lang)}</p>
            </div>
          </div>
          <div className="img__wrapper">
            <img
              src={require("../assets/images/Unity_Tower_second_floor/UT_2P_traditional_v2.png")}
              alt=""
            />
          </div>
          <div className="offices-schema__wrapper-bottom">
            <ul>
              <li>{t("1 office room / 1 person", lang)}</li>
              <li>{t("Reception desk", lang)}</li>
              <li>{t("3 conference rooms", lang)}</li>
              <li>{t("Kitchen", lang)}</li>
              <li>{t("Relax area", lang)}</li>
            </ul>
            <a
              href={
                lang === "en"
                  ? require("../assets/pdf/UNITY-TOWER-2nd-floor-traditional_v2-en.pdf")
                  : require("../assets/pdf/UNITY-TOWER-2nd-floor-traditional_v2.pdf")
              }
              target="_blank"
              rel="noreferrer"
              className="btn-custom-back btn-custom-back--orange"
            >
              {t("Download Floor Plan", lang)}
            </a>
          </div>
        </div>
      </div>
      {/* <div>
        {lang === "en" ? (
          <img
            className="img-fluid"
            src={require("../assets/images/offices-UTower-bottom-en.jpg")}
            alt=""
          />
        ) : (
          <img
            className="img-fluid"
            src={require("../assets/images/offices-UTower-bottom-pl.jpg")}
            alt=""
          />
        )}
      </div> */}
    </Slider>
  )
}

export default OfficesSliderTowerLowerFirstSecondFloor
